import dayjs from "dayjs";

import { Scalars } from "../generated/types";
import { ScalarMapping } from "./scalarExchange";

/* eslint-disable @typescript-eslint/no-explicit-any */
type Serializer<T> = (input: T) => any;
type Deserializer<T> = (value: any) => T;
/* eslint-enable @typescript-eslint/no-explicit-any */

interface TypedScalarMapping<T> extends ScalarMapping {
    serialize?: Serializer<T>;
    deserialize?: Deserializer<T>;
}
type ScalarMappingsByScalar = { [Scalar in keyof Scalars]: TypedScalarMapping<Scalars[Scalar]["output"]> };

export const SCALAR_MAPPING: Partial<ScalarMappingsByScalar> = {
    Date: {
        serialize: (value) => dayjs(value).format("YYYY-MM-DD"),
        deserialize: (value: string) => dayjs(value).toDate(),
    },
    DateTime: {
        serialize: (value) => dayjs(value).toISOString(),
        deserialize: (value: string) => dayjs(value).toDate(),
    },
    JSON: {
        serialize: (value) => value,
        deserialize: (value) => value,
    },
};
